import { authControllerVerifyEmail } from '@/api/auth/auth'

export type EmailVerificationStatus = 'success' | 'error' | 'none'

export const verifyEmail = async (token: string): Promise<EmailVerificationStatus> => {
  try {
    await authControllerVerifyEmail({ token })
    return 'success'
  } catch {
    return 'error'
  }
}
